import { ProductLifecycleStage } from 'src/shared/types/product';

export type ProductAction = 'reorder' | 'place-order' | 'purchase-sample';

const REORDER_STAGES = new Set<ProductLifecycleStage['id']>([
  'ordered',
  'order_produced'
]);

const PLACE_ORDER_STAGES = new Set<ProductLifecycleStage['id']>([
  'samples_ordered',
  'samples_produced'
]);

/**
 * Actions the customer can take on a product, derived from its lifecycle
 * because the products list does not carry quotes or bulk orders.
 *
 * - Reorder: a bulk order has been placed, i.e. the product reached the
 *   `ordered` stage (the stage only starts once an order is placed).
 * - Place order: a sample has been paid but no bulk order placed yet, i.e.
 *   the product sits at `samples_ordered` or `samples_produced`.
 * - Purchase sample: quotes are surfaced and no sample has been paid yet, i.e.
 *   the product sits at `quotes_received` (paying a sample moves it on).
 */
const getProductActions = (
  lifecycle: ProductLifecycleStage[]
): ProductAction[] => {
  if (lifecycle.length === 0) {
    return [];
  }

  const currentStage = lifecycle.find((stage) => stage.status !== 'done');

  if (!currentStage || REORDER_STAGES.has(currentStage.id)) {
    return ['reorder'];
  }

  if (PLACE_ORDER_STAGES.has(currentStage.id)) {
    return ['place-order'];
  }

  if (currentStage.id === 'quotes_received') {
    return ['purchase-sample'];
  }

  return [];
};

export default getProductActions;
